<template>
<div>
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <div v-show="filterData.length" class="">
        <span class="header">FILTERS APPLIED:</span>
      </div>
    </div>
    <div class="d-flex align-items-center w-75 justify-content-end">
      <div class="px-3">
        <span>Filters:</span>
      </div>
      <div class="d-flex justify-content-end">
        <div>
          <label class="pr-1 mb-0">
            <b-input-group class="advance-search-field">
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-md SearchInput"
                @keydown.enter.native="onUpdateFilter"
              ></b-form-input>
              <b-input-group-prepend class="btn2 btn2-tertiary">
                <span 
                  class="input-group-text bg-white" 
                  :class="1 == 2 ? '' : 'right-search-border'" 
                  @click="onUpdateFilter"
                >
                  <i class="uil-search"></i>
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </label>
        </div>
        <div style="width: 200px;"  class="px-1">
          <multiselect
            ref="Substatus"
            autocomplete
            :multiple="false"
            v-model="filterItems.substatus"
            :options="substatusOptions"
            :searchable="true"
            placeholder="Substatus"
            :clear-on-select="false"
            :close-on-select="false"
            :show-labels="false"

            track-by="name"
            label="name"
            @input="onInputFilter(filterItems.substatus, 'Substatus')"
          ></multiselect>
        </div>
        <div style="width: 150px;"  class="px-1">
          <multiselect
            ref="Status"
            autocomplete
            :multiple="false"
            v-model="filterItems.status"
            :options="statusOptions"
            :searchable="true"
            placeholder="Status"
            :clear-on-select="false"
            :close-on-select="false"
            :show-labels="false"

            track-by="name"
            label="name"
            @input="onInputFilter(filterItems.status, 'Status')"
          ></multiselect>
        </div>
        <div style="width: 150px;" class="pl-1">
          <multiselect
            v-model="filterItems.assignTo"
            :options="assignToOptions"
            :searchable="true"
            placeholder="Assign To"
            :clear-on-select="false"
            :close-on-select="true"
            :show-labels="false"

            track-by="full_name"
            label="full_name"
            @input="onInputFilter(filterItems.assignTo, 'Assign To')"
            :multiple="false"
          ></multiselect>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center mt-2">

        <div 
          class="mr-2"
          v-for="(data, idx) in filterData"
          :key="idx"
        >
          <div class="chip"  style="border: 1px solid #0300133D !important;">
            <span class="sub-header">{{ data.field }}: </span>
            <span style="font-size: 15px;">{{ data.value }}</span>
            <span class="closebtn" @click="removeFilter(idx, data.field)">&times;</span>
          </div>
        </div>
        <div v-show="filterData.length">
          <b-button class="custom-button py-1" size="sm" @click="removeFilter">
            Clear Filters
          </b-button>
        </div>
  </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Dropdown from '@src/static/dropdown'

export default {
  components: {
    Multiselect,
  },
  props:{
  },
  computed: {
 
  },
  data() {
    return {
      statusOptions: [],
      substatusOptions: [],
      assignToOptions: [],
      filterItems: {
        status: '',
        substatus: '',
        assignTo: ''
      },
      filterData: [],
      filter: ''
    }
  },
  methods:{
    onInputFilter(val, field) {

      if(Array.isArray(val)) {
        val.name = val.map(value => value.name).join(", ")
      }

      let data = this.filterData
      let newData = []
      let isFilter = false
      let value = val.full_name ? val.full_name : typeof val == 'object' ?  val.name : val
      if(val && field){
        for(let key in data){
          let item = data[key].field
          if(item == field){
            isFilter = true
            data[key].value = value
          }
          newData.push(data[key])
        }
  
        if(isFilter){
          this.filterData = newData
        }else{
          this.filterData.push({
            field: field,
            value: value
          })
        }
      }

      this.onUpdateFilter()
    },
    removeFilter(idx, field) {
      if(field){
        let formattedField = this.camelize(field)
        this.filterItems[`${formattedField}`] = ''
        this.filterData.splice(idx, 1)
      }else{
        this.filterData = []
        this.filterItems = {
          status: '',
        }
      } 
      
      this.onUpdateFilter()
    },
    onUpdateFilter(){
      let items = this.filterItems && typeof this.filterItems == 'object' ? this.filterItems : ''

      let filter = {
        status: items && typeof items.status == 'object' && items.status.value ? [parseInt(items.status.value)] : [],
        substatus: items && typeof items.substatus == 'object' && items.substatus.value ? items.substatus.value : '',
        assignTo: items && typeof items.assignTo == 'object' && items.assignTo._id ? items.assignTo._id : '',
        filter: this.filter || ''
      }
      this.$emit('onFilter', filter || '')
    },
    fetchFilterOptions(){
      let { statusList, subStatusList } = Dropdown
      for(let status of statusList) {
        let { value, text } = status
        this.statusOptions.push({ value, name: text })
      }

      for(let status of subStatusList) {
        let { value, text } = status
        this.substatusOptions.push({ value, name: text })
      }

      this.$store.dispatch('user/pagination')
      .then(res => {
        if(res && res.data) {
          this.assignToOptions = res.data.data
        }
      })
    },
    camelize(str) {
      return str
        .replace(/\s(.)/g, function($1) { return $1.toUpperCase(); })
        .replace(/\s/g, '')
        .replace(/^(.)/, function($1) { return $1.toLowerCase(); });
    },
    onRemoveFilters(val, field) {
      if(val.length == 1 && field) {
        for(let key in this.filterData) {
          if(this.filterData[key].field == field) {
            this.removeFilter(parseInt(key), field)
          }
        }
      }
    }
  },
  mounted(){
    this.fetchFilterOptions()
  },
  watch: {
    'filterItems.status': function (status) {
      this.substatusOptions = []
      let { subStatusList } = Dropdown
      if(status && status.value) {
        for(let status of subStatusList) {
          let { value, text } = status
          if(value == status.value) {
            this.substatusOptions.push({ value, name: text })
          }
        }
      } else {
        for(let status of subStatusList) {
          let { value, text } = status
          this.substatusOptions.push({ value, name: text })
        }
      }
    }
  },
}
</script>